/*! sm-kokubordi.js 1.0.0 (08.10.2026): nettur vafrakökuborði á Shopify Customer Privacy API.
   Birtist aðeins þegar: stillingin "Nota eigin borða" er á (eða ?sm_kokur=1 til prófunar), Shopify-borðinn er EKKI
   í síðunni (privacy-banner/privacy-banner.js, áður storefront-banner.js, eða #shopify-pc__banner), svæðið krefst samþykkis (shouldShowBanner) og gesturinn hefur ekki valið
   (getTrackingConsent 'no_interaction'). Valið fer með setTrackingConsent til Shopify, svo app-pixlar
   (Google & YouTube, Facebook & Instagram, Judge.me) virða það. Ekkert skrunlás, engin fókusgildra, ESC lokar ekki.
   Tengill með href "#sm-kokur" (t.d. í fæti) opnar stillingarnar aftur; ef Shopify-borðinn er á opnast hans gluggi. */
(function () {
  'use strict';
  /* P2-C03 (21.10): persónuverndartengill innbyggða Shopify-borðans er http://<lén>/policies/... (Settings > Customer privacy gefur http).
     Hann er gerður að slóð á sama léni án samskiptareglu um leið og borðinn birtist, á öllum tungumálum. */
  (function () {
    function lagaTengla() {
      ['shopify-pc__banner', 'shopify-pc__prefs'].forEach(function (id) {
        var r = document.getElementById(id); if (!r) return;
        [].forEach.call(r.querySelectorAll('a[href^="http://"]'), function (a) {
          try { var u = new URL(a.getAttribute('href')); if (u.hostname === location.hostname) a.setAttribute('href', u.pathname + u.search + u.hash); } catch (e) {}
        });
      });
    }
    var bidTengla = false;
    lagaTengla();
    if (window.MutationObserver) {
      new MutationObserver(function (m) {
        for (var i = 0; i < m.length; i++) for (var j = 0; j < m[i].addedNodes.length; j++) {
          var a = m[i].addedNodes[j];
          if (a.nodeType === 1 && (/^shopify-pc__/.test(a.id || '') || (a.querySelector && a.querySelector('[id^="shopify-pc__"]')))) {
            if (!bidTengla) { bidTengla = true; setTimeout(function () { bidTengla = false; lagaTengla(); }, 0); }
            return;
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
  /* 21.10 (FI): innbyggði Shopify-borðinn (storefront-banner.js) sækir íslenskan texta úr Customer privacy og á sér engin
     þýðingaskil í Admin API. Á ensku útgáfunni (html lang en) er hann þýddur hér þegar hann birtist; íslenskan er óbreytt.
     Borðinn hverfur úr síðunni þegar eigandinn fjarlægir hann á útgáfudegi og eigin borðinn tekur við (hann er þýddur með t). */
  (function () {
    var mal = String(document.documentElement.lang || '').toLowerCase();
    if (mal.indexOf('en') !== 0) return;
    var N = function (t) { return String(t).replace(/&amp;/g, '&').replace(/\s+/g, ' ').trim(); };
    var ORD = {};
    [
      ['Vefkökur & persónuvernd', 'Cookies & privacy'],
      ['Við notum vefkökur (cookies) til að bæta upplifun þína á vefsíðunni, greina notkun hennar og birta viðeigandi efni. Þú getur sjálfur valið hvaða kökur þú samþykkir. Nauðsynlegar vefkökur eru alltaf virkar til að síðan virki eðlilega. Með því að smella á „Samþykkja“ veitir þú samþykki fyrir notkun vefkaka í samræmi við persónuverndarstefnu okkar.',
       'We use cookies to improve your experience on the website, analyse how it is used and show relevant content.\n\nYou choose which cookies you accept. Necessary cookies are always active so the site works properly.\n\nBy clicking “Accept” you consent to the use of cookies in accordance with our privacy policy.'],
      ['Persónuverndarstefna', 'Privacy policy'],
      ['Stilla vefkökur', 'Manage cookies'],
      ['Samþykkja', 'Accept'],
      ['Hafna', 'Decline'],
      ['Vefkökur og persónuverndarstillingar', 'Cookie and privacy settings'],
      ['Samþykkja allt', 'Accept all'],
      ['Hafna öllu', 'Decline all'],
      ['Vista val', 'Save choices'],
      ['Þú stjórnar gögnum þínum', 'You control your data'],
      ['Kynntu þér hvaða vefkökur við notum og veldu sjálfur hvaða kökur þú vilt leyfa.', 'See which cookies we use and choose which ones you want to allow.'],
      ['Nauðsynlegar vefkökur', 'Necessary cookies'],
      ['Þessar vefkökur eru nauðsynlegar svo vefsíðan virki eðlilega, til dæmis fyrir innskráningu, körfu og greiðsluferli. Ekki er hægt að slökkva á þeim.', 'These cookies are necessary for the website to work properly, for example for sign-in, the cart and checkout. They cannot be switched off.'],
      ['Sérstilling', 'Personalisation'],
      ['Þessar vefkökur muna val þitt og stillingar til að gera heimsóknir þínar persónulegri og þægilegri.', 'These cookies remember your choices and settings to make your visits more personal and convenient.'],
      ['Markaðssetning', 'Marketing'],
      ['Þessar vefkökur eru notaðar til að sýna viðeigandi auglýsingar og mæla árangur markaðssetningar, bæði á þessari síðu og annars staðar á netinu.', 'These cookies are used to show relevant ads and measure the results of marketing, both on this site and elsewhere on the web.'],
      ['Tölfræði', 'Analytics'],
      ['Þessar vefkökur hjálpa okkur að skilja hvernig vefsíðan er notuð. Upplýsingarnar nýtum við til að bæta upplifun og virkni síðunnar.', 'These cookies help us understand how the website is used. We use the information to improve the experience and functionality of the site.']
    ].forEach(function (r) { ORD[N(r[0])] = r[1]; });
    function pyda() {
      ['shopify-pc__banner', 'shopify-pc__prefs'].forEach(function (id) {
        var r = document.getElementById(id); if (!r) return;
        var w = document.createTreeWalker(r, NodeFilter.SHOW_TEXT), n, lista = [];
        while ((n = w.nextNode())) lista.push(n);
        lista.forEach(function (t) {
          var e = ORD[N(t.nodeValue)];
          if (e === undefined) return;
          var fyrir = /^\s/.test(t.nodeValue) ? ' ' : '', eftir = /\s$/.test(t.nodeValue) ? ' ' : '';
          t.nodeValue = fyrir + e + eftir;
        });
      });
    }
    var bid = false;
    function bidja() { if (bid) return; bid = true; setTimeout(function () { bid = false; pyda(); }, 0); }
    pyda();
    if (window.MutationObserver) {
      new MutationObserver(function (m) {
        for (var i = 0; i < m.length; i++) for (var j = 0; j < m[i].addedNodes.length; j++) {
          var a = m[i].addedNodes[j];
          if (a.nodeType === 1 && (/^shopify-pc__/.test(a.id || '') || (a.querySelector && a.querySelector('[id^="shopify-pc__"]')))) return bidja();
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
  var el = document.querySelector('[data-sm-kokubordi]');
  if (!el) return;
  var q = (location.search.match(/[?&]sm_kokur=(\d)/) || [])[1] || '';
  var virkt = el.getAttribute('data-virkt') === 'true' || q !== '';
  /* 23.10 (S7): Shopify-borðinn heitir nú privacy-banner/privacy-banner.js (áður storefront-banner.js) og bætist við síðuna seint
     (#shopify-pc__banner). Greint í hvert sinn sem spurt er: skriftan (hvaða útgáfa sem er) EÐA borðinn sjálfur. */
  function shopifyBordi() {
    return !!(document.getElementById('shopify-pc__banner') || document.querySelector('script[src*="privacy-banner/"], script[src*="storefront-banner"]'));
  }
  var hannun = !!(window.Shopify && window.Shopify.designMode);
  var api = null, opid = false;
  var val = el.querySelector('[data-kb-val-spjald]');
  var adal = el.querySelector('[data-kb-adal]');

  function hlada(cb) {
    if (api) return cb(api);
    if (!(window.Shopify && typeof window.Shopify.loadFeatures === 'function')) return cb(null);
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err || !window.Shopify.customerPrivacy) return cb(null);
      api = window.Shopify.customerPrivacy; cb(api);
    });
  }
  function syna() { el.hidden = false; opid = true; }
  var fraFaeti = null; /* tengillinn (#sm-kokur) sem opnaði borðann aftur, ef svo var */
  /* 20.10 (QA17 6): þegar borðinn lokast og fókus var í honum fer fókus á tengilinn sem opnaði hann, annars á efni síðunnar (ekki BODY) */
  function fela() {
    var fokusInni = el.contains(document.activeElement);
    var aftur = fraFaeti; fraFaeti = null;
    el.hidden = true; opid = false; stillingar(false);
    if (fokusInni) {
      var m = (aftur && document.contains(aftur)) ? aftur : document.getElementById('MainContent');
      if (m && m.focus) { try { m.focus({ preventScroll: true }); } catch (e) { m.focus(); } }
    }
  }
  function stillingar(opna) {
    if (!val || !adal) return;
    val.hidden = !opna; adal.hidden = !!opna;
    var s = el.querySelector('[data-kb="stillingar"]'); if (s) s.setAttribute('aria-expanded', opna ? 'true' : 'false');
    if (opna) { var f = val.querySelector('input:not(:disabled)'); if (f) f.focus({ preventScroll: true }); }
  }
  function vista(c) {
    var consent = { analytics: !!c.analytics, marketing: !!c.marketing, preferences: !!c.preferences, sale_of_data: !!c.marketing };
    var lokid = function () {
      fela();
      try { document.dispatchEvent(new CustomEvent('sm:kokur', { detail: consent })); } catch (e) {}
    };
    hlada(function (cp) {
      if (!cp) return lokid();
      try { cp.setTrackingConsent(consent, lokid); } catch (e) { lokid(); }
    });
  }
  el.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-kb]'); if (!b) return;
    var a = b.getAttribute('data-kb');
    if (a === 'samthykkja') vista({ analytics: true, marketing: true, preferences: true });
    else if (a === 'hafna') vista({ analytics: false, marketing: false, preferences: false });
    else if (a === 'stillingar') stillingar(true);
    else if (a === 'til-baka') { if (fraFaeti) fela(); else stillingar(false); } /* opnað úr fæti: Til baka lokar (QA17 7) */
    else if (a === 'vista') {
      var an = el.querySelector('[data-kb-val="analytics"]'), ma = el.querySelector('[data-kb-val="marketing"]');
      vista({ analytics: !!(an && an.checked), marketing: !!(ma && ma.checked), preferences: !!(an && an.checked) });
    }
  });

  // Tengill "#sm-kokur" (fótur, persónuverndarstefna): opna stillingar aftur, með núverandi vali forvalið.
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest('a[href$="#sm-kokur"]'); if (!a) return;
    ev.preventDefault();
    if (!virkt || shopifyBordi()) {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
      return;
    }
    hlada(function (cp) {
      var nu = (cp && cp.currentVisitorConsent && cp.currentVisitorConsent()) || {};
      var an = el.querySelector('[data-kb-val="analytics"]'), ma = el.querySelector('[data-kb-val="marketing"]');
      if (an) an.checked = nu.analytics === 'yes';
      if (ma) ma.checked = nu.marketing === 'yes';
      fraFaeti = a;
      syna(); stillingar(true);
    });
  });

  window.SMKokur = { opna: function () { syna(); }, stillingar: function () { syna(); stillingar(true); } };

  if (!virkt) return;
  if (hannun) { syna(); return; }
  /* Öryggisnet: meðan Shopify-borðinn er í síðunni sýnum við ekki eigin borða (líka með ?sm_kokur). Ef Shopify-borðinn bætist við
     eftir að okkar er sýndur (hann kemur seint) er okkar falinn aftur. */
  if (window.MutationObserver) {
    var vakt = new MutationObserver(function (m) {
      if (!opid) return;
      for (var i = 0; i < m.length; i++) for (var j = 0; j < m[i].addedNodes.length; j++) {
        var a = m[i].addedNodes[j];
        if (a.nodeType === 1 && (a.id === 'shopify-pc__banner' || (a.querySelector && a.querySelector('#shopify-pc__banner')) || (a.tagName === 'SCRIPT' && /privacy-banner\//.test(a.getAttribute('src') || '')))) { fela(); return; }
      }
    });
    vakt.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { vakt.disconnect(); }, 15000);
  }
  if (shopifyBordi()) return;
  hlada(function (cp) {
    if (!cp) return;
    var svaedi = false, oval = false;
    try { svaedi = !!cp.shouldShowBanner(); oval = cp.getTrackingConsent() === 'no_interaction'; } catch (e) {}
    if (!((svaedi && oval) || q === '2')) return;
    /* stutt bið, svo Shopify-borðinn (sem bætist við seint) nái að birtast áður en við ákveðum */
    setTimeout(function () { if (!shopifyBordi()) syna(); }, 1200);
  });
})();
